import {createRouter, createWebHistory} from 'vue-router'

// Define route components
const Dashboard = require('./components/views/Dashboard').default

const SalesDashboard = require('./components/views/SalesDashboard').default

const Transactions = require('./components/views/Sales/Transactions').default
const TransactionsNew = require('./components/views/Sales/New').default
const TransactionsView = require('./components/views/Sales/View').default

const PaymentLinks = require('./components/views/Sales/PaymentLinks').default
const PaymentLinksView = require('./components/views/Sales/PaymentLinks/View').default
const PaymentLinksNew = require('./components/views/Sales/PaymentLinks/New').default

const UsersList = require('./components/views/Users/List').default
const UsersCreate = require('./components/views/Users/Create').default
const UsersView = require('./components/views/Users/View').default
const UsersDetail = require('./components/views/Users/Detail').default
const UsersActivity = require('./components/views/Users/Activity').default
const JournalistsImport = require('./components/views/Users/Import').default
const JournalistCreate = require('./components/views/Users/CreateJournalist').default

const AdminList = require('./components/views/Admin/List').default
const AdminPermissions = require('./components/views/Admin/Permissions').default

const AccountsView = require('./components/views/Accounts/View').default
const AccountFlagsView = require('./components/views/Accounts/Flags').default
const AccountPro = require('./components/views/Accounts/ManagePro').default
const AccountCredits = require('./components/views/Accounts/Credits').default
const AccountProductCredits = require('./components/views/Accounts/ProductCredits').default
const AccountFeatures = require('./components/views/Accounts/Features').default
const AccountGroupMembership = require('./components/views/Accounts/Groups').default
const AccountUserPermissions = require('./components/views/Accounts/UserPermissions').default
const AccountNotes = require('./components/views/Accounts/NotesDrawer').default

const SubscriptionsView = require('./components/views/Subscriptions/View').default
const SubscriptionEnablements = require('./components/views/Subscriptions/Enablements').default
const SubscriptionPause = require('./components/views/Subscriptions/Pause').default

const PaymentMethodView = require('./components/views/Accounts/PaymentMethod').default

const OrderView = require('./components/views/Orders/View').default
const OrderCreate = require('./components/views/Orders/Create').default

const BusinessesView = require('./components/views/Businesses/View').default
const BusinessCreate = require('./components/views/Businesses/Create').default

const ReleasesList = require('./components/views/Releases/List').default
const ReleasesView = require('./components/views/Releases/View').default
const ReleasesSchedule = require('./components/views/Releases/Schedule').default
const ReleasesScheduleNew = require('./components/views/Releases/Schedule/New').default
const ReleasesAnalytics = require('./components/views/Releases/Analytics').default

const PromotionsList = require('./components/views/Promotions/List').default
const PromotionsCreate = require('./components/views/Promotions/Create').default
const PromotionsShow = require('./components/views/Promotions/Show').default

const ContainersList = require('./components/views/Containers/List').default
const ContainersView = require('./components/views/Containers/View').default
const ContainersCreate = require('./components/views/Containers/Create').default
const ContainersAccountFlags = require('./components/views/Containers/AccountFlags').default
const ContainerFeatures = require('./components/views/Containers/Features').default

const KnowledgebaseList = require('./components/views/Knowledgebase/List').default
const KnowledgebaseView = require('./components/views/Knowledgebase/View').default
const KnowledgebaseCreate = require('./components/views/Knowledgebase/Create').default

const KnowledgebaseCategoriesList = require('./components/views/Knowledgebase/Categories/List').default
const KnowledgebaseCategoriesView = require('./components/views/Knowledgebase/Categories/View').default
const KnowledgebaseCategoriesCreate = require('./components/views/Knowledgebase/Categories/Create').default

const FAQList = require('./components/views/FAQ/List').default
const FAQView = require('./components/views/FAQ/View').default
const FAQCreate = require('./components/views/FAQ/Create').default

const FAQCategoriesList = require('./components/views/FAQ/Categories/List').default
const FAQCategoriesView = require('./components/views/FAQ/Categories/View').default
const FAQCategoriesCreate = require('./components/views/FAQ/Categories/Create').default

const BlogList = require('./components/views/Blog/List').default
const BlogView = require('./components/views/Blog/View').default
const BlogCreate = require('./components/views/Blog/Create').default

const ProfessionalWritingList = require('./components/views/ProfessionalWriting/List').default
const ProfessionalWritingView = require('./components/views/ProfessionalWriting/View').default
const ProfessionalWritingDraftPressRelease = require('./components/views/ProfessionalWriting/DraftPressRelease').default
const ProfessionalWritingCopify = require('./components/views/ProfessionalWriting/Copify').default
const ProfessionalWritingCopifyJob = require('./components/views/ProfessionalWriting/CopifyJob').default

const MediaRequestList = require('./components/views/MediaRequests/List').default
const MediaRequestCreate = require('./components/views/MediaRequests/Create').default
const MediaRequestView = require('./components/views/MediaRequests/View').default
const MediaRequestRepliesList = require('./components/views/MediaRequests/ReplyList').default
const MediaRequestRepliesView = require('./components/views/MediaRequests/ReplyView').default

const PublicationsList = require('./components/views/Publications/List').default
const PublicationsView = require('./components/views/Publications/View').default

const PublicationsIPList = require('./components/views/Publications/IP/List').default
const PublicationsIPView = require('./components/views/Publications/IP/View').default

const EventList = require('./components/views/Event/List').default
const EventCreate = require('./components/views/Event/Create').default
const EventView = require('./components/views/Event/View').default

const AccountGroupList = require('./components/views/AccountGroups/List').default
const AccountGroupCreate = require('./components/views/AccountGroups/Create').default
const AccountGroupView = require('./components/views/AccountGroups/View').default
const AccountGroupFlags = require('./components/views/AccountGroups/Flags').default

const PackageList = require('./components/views/Package/List').default
const PackageView = require('./components/views/Package/View').default
const PackageCreate = require('./components/views/Package/Create').default

const ProductLicencesList = require('./components/views/ProductLicences/List').default
const ProductLicencesCreate = require('./components/views/ProductLicences/Create').default
const ProductLicencesShow = require('./components/views/ProductLicences/View').default

const routes = [
    {
        path: '/home',
        component: Dashboard,
        name: 'home'
    },
    {
        path: '/sales',
        component: Transactions,
        name: 'sales',
        children: [
            {
                path: '/sales/new/:userId?',
                component: TransactionsNew,
                name: 'sales.new',
            },
            {
                path: '/sales/invoice/:invoice',
                component: TransactionsView,
                name: 'sales.view',
            },
        ]
    },
    {
        path: '/sales/links',
        component: PaymentLinks,
        name: 'payment.links',
        children: [
            {
                path: '/sales/links/view/:link',
                component: PaymentLinksView,
                name: 'payment.links.view',
            },
            {
                path: '/sales/links/new',
                component: PaymentLinksNew,
                name: 'payment.links.new',
            },
        ]
    },
    {
        path: '/sales-dashboard',
        component: SalesDashboard,
        name: 'sales-dashboard'
    },

    {
        path: '/users',
        component: UsersList,
        name: 'users.list',
        props: true,
        children: [
            {
                path: ':userId(\\d+)',
                component: UsersView,
                name: 'users.show',
                children: [
                    {
                        path: 'activity',
                        component: UsersActivity,
                        name: 'users.activity',
                    },
                    {
                        path: 'admin/permissions',
                        component: AdminPermissions,
                        name: 'users.admin.permissions',
                        props: true,
                    },
                    {
                        path: 'productlicences',
                        component: ProductLicencesList,
                        name: 'users.productlicences',
                        props: true,
                        children: [
                            {
                                path: 'create',
                                component: ProductLicencesCreate,
                                name: 'users.productlicences.create',
                                props: true,
                            },
                            {
                                path: ':licenceId(\\d+)',
                                component: ProductLicencesShow,
                                name: 'users.productlicences.show',
                                props: true,
                            },
                        ]
                    },
                ],
            },
            {
                path: ':userId(\\d+)/detail',
                component: UsersDetail,
                name: 'users.detail',
            },
            {
                path: 'create',
                component: UsersCreate,
                name: 'users.create',
            },
            {
                path: 'create/journalist',
                component: JournalistCreate,
                name: 'users.create_journalist'
            },
            {
                path: 'import',
                component: JournalistsImport,
                name: 'users.import',
            },
        ]
    },

    {
        path: '/account/:accountId',
        component: AccountsView,
        name: 'accounts.show',
        children: [
            {
                path: 'flags',
                component: AccountFlagsView,
                name: 'account.flags.show',
                props: true
            },
            {
                path: 'features',
                component: AccountFeatures,
                name: 'account.features',
                props: true
            },
            {
                path: 'groups',
                component: AccountGroupMembership,
                name: 'account.groups.show',
                props: true
            },
            {
                path: 'notes',
                component: AccountNotes,
                name: 'account.notes.show',
                props: true
            },
            {
                path: 'business/:businessId',
                component: BusinessesView,
                name: 'business.show',
            },
            {
                path: 'business',
                component: BusinessCreate,
                name: 'business.create'
            },
            {
                path: 'subscription',
                component: SubscriptionsView,
                name: 'subscriptions.show',
                children: [
                    {
                        path: ':subscriptionId/enablements',
                        component: SubscriptionEnablements,
                        name: 'subscriptions.enablements',
                    },
                    {
                        path: ':subscriptionId/pause',
                        component: SubscriptionPause,
                        name: 'subscriptions.pause',
                        props: true,
                    },
                ]
            },
            {
                path: 'pay-method',
                component: PaymentMethodView,
                name: 'paymentmethod.show',
            },
            {
                path: 'order/:orderId',
                component: OrderView,
                name: 'order.show',
                props: true,
            },
            {
                path: 'order/create',
                component: OrderCreate,
                name: 'order.create',
                props: true,
            },
            {
                path: 'pro',
                component: AccountPro,
                name: 'account.pro',
                props: true,
            },
            {
                path: 'credits',
                component: AccountCredits,
                name: 'account.credits',
                props: true,
            },
            {
                path: 'productcredits',
                component: AccountProductCredits,
                name: 'account.productcredits',
                props: true,
            },
            {
                path: 'user/:userId/permissions',
                component: AccountUserPermissions,
                name: 'account.users.permissions',
                props: true,
            },
        ]
    },

    {
        path: '/admin',
        component: AdminList,
        name: 'admin.list',
        props: true,
    },

    {
        path: '/promotions',
        component: PromotionsList,
        name: 'promotions.list',
        children: [
            {
                path: 'create',
                component: PromotionsCreate,
                name: 'promotions.create',
            },
            {
                path: ':code',
                component: PromotionsShow,
                name: 'promotions.show',
            }
        ]
    },
    {
        path: '/publications',
        name: 'publications.list',
        component: PublicationsList,
        children: [
            {
                path: ':publicationId(\\d+)',
                component: PublicationsView,
                name: 'publications.show'
            }
        ]
    },
    {
        path: '/publications/ip/',
        name: 'publications.ip.list',
        component: PublicationsIPList,
        children: [
            {
                path: ':publicationIpId(\\d+)',
                component: PublicationsIPView,
                name: 'publications.ip.show'
            }
        ]
    },
    {
        path: '/containers',
        component: ContainersList,
        name: 'containers.list',
        children: [
            {
                path: ':containerId(\\d+)',
                component: ContainersView,
                name: 'containers.show',
                props: true,
                children: [
                    {
                        path: 'account-flags',
                        component: ContainersAccountFlags,
                        name: 'containers.show.account_flags',
                        props: true,
                    },
                    {
                        path: 'features',
                        component: ContainerFeatures,
                        name: 'containers.features',
                        props: true,
                    },
                ]
            },
            {
                path: 'create',
                component: ContainersCreate,
                name: 'containers.create',
                props: true,
            }
        ]
    },

    {
        path: '/blog',
        component: BlogList,
        name: 'blog.list',
        children: [
            {
                path: ':blogId(\\d+)',
                component: BlogView,
                name: 'blog.show',
                props: true,
            },
            {
                path: 'blog',
                component: BlogCreate,
                name: 'blog.create',
                props: true,
            },
        ]
    },

    {
        path: '/knowledgebase',
        component: KnowledgebaseList,
        name: 'knowledgebase.list',
        children: [
            {
                path: ':knowledgebaseId(\\d+)',
                component: KnowledgebaseView,
                name: 'knowledgebase.show',
                props: true,
            },
            {
                path: 'create',
                component: KnowledgebaseCreate,
                name: 'knowledgebase.create',
                props: true,
            }
        ]
    },

    {
        path: '/knowledgebase/categories',
        component: KnowledgebaseCategoriesList,
        name: 'knowledgebase.categories.list',
        children: [
            {
                path: ':categoryId(\\d+)',
                component: KnowledgebaseCategoriesView,
                name: 'knowledgebase.categories.show',
                props: true,
            },
            {
                path: 'create',
                component: KnowledgebaseCategoriesCreate,
                name: 'knowledgebase.categories.create',
                props: true,
            }
        ]
    },

    {
        path: '/knowledgebase',
        component: KnowledgebaseList,
        name: 'knowledgebase.list',
        children: [
            {
                path: ':knowledgebaseId(\\d+)',
                component: KnowledgebaseView,
                name: 'knowledgebase.show',
                props: true,
            },
            {
                path: 'create',
                component: KnowledgebaseCreate,
                name: 'knowledgebase.create',
                props: true,
            }
        ]
    },

    {
        path: '/faq/categories',
        component: FAQCategoriesList,
        name: 'faq.categories.list',
        children: [
            {
                path: ':categoryId(\\d+)',
                component: FAQCategoriesView,
                name: 'faq.categories.show',
                props: true,
            },
            {
                path: 'create',
                component: FAQCategoriesCreate,
                name: 'faq.categories.create',
                props: true,
            }
        ]
    },

    {
        path: '/faq',
        component: FAQList,
        name: 'faq.list',
        children: [
            {
                path: ':faqId(\\d+)',
                component: FAQView,
                name: 'faq.show',
                props: true,
            },
            {
                path: 'create',
                component: FAQCreate,
                name: 'faq.create',
                props: true,
            }
        ]
    },

    {
        path: '/professional-writing',
        component: ProfessionalWritingList,
        name: 'professionalWriting.list',
        children: [
            {
                path: ':professionalWritingId(\\d+)',
                component: ProfessionalWritingView,
                name: 'professionalWriting.show',
                children: [
                    {
                        path: 'draft',
                        component: ProfessionalWritingDraftPressRelease,
                        name: 'professionalWriting.draftPressRelease',
                        props: true
                    }
                ]
            },
        ],
    },
    {
        path: '/professional-writing/copify',
        component: ProfessionalWritingCopify,
        name: 'professionalWriting.copify',
        children: [
            {
                path: 'job/:jobId(\\d+)',
                component: ProfessionalWritingCopifyJob,
                name: 'professionalWriting.copify.job',
                props: {}
            }
        ]
    },
    {
        path: '/events',
        component: EventList,
        name: 'event.list',
        children: [
            {
                path: 'create',
                component: EventCreate,
                name: 'event.create',
                props: true,
            },
            {
                path: ':eventId(\\d+)',
                component: EventView,
                name: 'event.show',
            },
        ]
    },

    {
        path: '/releases',
        component: ReleasesList,
        name: 'releases.list',
        children: [
            {
                path: ':releaseId(\\d+)',
                component: ReleasesView,
                name: 'releases.show',
                children: [
                    {
                        path: 'schedule/new',
                        component: ReleasesScheduleNew,
                        name: 'releases.schedule.new',
                        props: true
                    },
                    {
                        path: 'schedule/:schedule(\\d+)',
                        component: ReleasesSchedule,
                        name: 'releases.schedule',
                        props: true
                    },
                    {
                        path: 'analytics',
                        component: ReleasesAnalytics,
                        name: 'releases.analytics',
                        props: true
                    },
                ]
            }
        ]
    },
    {
        path: '/media-requests',
        component: MediaRequestList,
        name: 'mediarequests.list',
        children: [
            {
                path: 'create',
                component: MediaRequestCreate,
                name: 'mediarequests.create',
            },
            {
                path: ':mediaRequestId(\\d+)',
                component: MediaRequestView,
                name: 'mediarequests.show',
                children: [
                    {
                        path: 'replies',
                        component: MediaRequestRepliesList,
                        name: 'mediarequests.replies.list',
                        props: true,
                        children: [
                            {
                                path: ':reply(\\d+)',
                                component: MediaRequestRepliesView,
                                name: 'mediarequests.replies.show',
                                props: true,
                            }
                        ]
                    }
                ]
            },
        ]
    },
    {
        path: '/account-groups',
        component: AccountGroupList,
        name: 'accountgroups.list',
        children: [
            {
                path: 'create',
                component: AccountGroupCreate,
                name: 'accountgroups.create',
            },
            {
                path: ':id(\\d+)',
                component: AccountGroupView,
                name: 'accountgroups.show',
                children: [
                    {
                        path: 'flags',
                        component: AccountGroupFlags,
                        name: 'accountGroups.flags',
                        props: true
                    },
                ]
            },
        ]
    },
    {
        path: '/packages',
        component: PackageList,
        name: 'packages.list',
        children: [
            {
                path: 'create',
                component: PackageCreate,
                name: 'packages.create',
            },
            {
                path: ':id(\\d+)',
                component: PackageView,
                name: 'packages.show',
            },
        ]
    },
];

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { left: 0, top: 0 }
    }
});

export default router
